import {
  curCoreClient, GetBaseStationCnxStatusTimeSeriesReply, GetBaseStationMeanPERTimeSeriesReply,
  GetBaseStationTrafficTimeSeriesReply,
  GetBaseStationTrafficTimeSeriesReq,
  GetBaseStationUniqueDevicesTimeSeriesReply
} from './CoreClient';
import _ from 'lodash';
import { HttpResponse } from '@/types/http';
import { BaseStation } from '@/types/core';

export class BssService {

  public async getBssList(query: GetBssQuery): Promise<HttpResponse & GetBssReply> {

    const allBssReply = await this.getAllBaseStations();
    
    if(allBssReply.errorMsg)
      return Promise.resolve({errorMsg:allBssReply.errorMsg, httpCode:allBssReply.httpCode});

    let allBaseStations = allBssReply.bssList as BaseStation[];

    if (query.filter) {

      allBaseStations = allBaseStations.filter((bs:BaseStation) => {

        //one of the the base station Ids is a number and so must be cast as a string first
        if (bs.lrrId.toString().toLowerCase().includes(query.filter.toLowerCase()))
          return true;

        if (bs.lrrUuid && bs.lrrUuid.toString().toLowerCase().includes(query.filter.toLowerCase()))
          return true;

        if (bs.enterpriseId && bs.enterpriseId.toLowerCase().includes(query.filter.toLowerCase()))
          return true;

        if (bs.name && String(bs.name)?.toLowerCase().includes(query.filter.toLowerCase())) {
          return true;
        }
        
        return false;
      });
    }

    return Promise.resolve({bssPageList:this.paginateBssList(allBaseStations, query.pageSize)});
  }

  public async getBaseStationTrafficTimeSeries(query: GetBaseStationTrafficTimeSeriesReq):Promise<HttpResponse & GetBaseStationTrafficTimeSeriesReply> {
    const reply = await curCoreClient.getBaseStationTrafficTimeSeries(query);
    if (reply.errorMsg) {
      return Promise.resolve({errorMsg: reply.errorMsg, httpCode: reply.httpCode});
    }
    return Promise.resolve({timeSeries: reply.timeSeries});
  }

  public async getBaseStationUniqueDevicesTimeSeries(query: GetBaseStationTrafficTimeSeriesReq):Promise<HttpResponse & GetBaseStationUniqueDevicesTimeSeriesReply> {
    const reply = await curCoreClient.getBaseStationUniqueDevicesTimeSeries(query);
    if (reply.errorMsg) {
      return Promise.resolve({errorMsg: reply.errorMsg, httpCode: reply.httpCode});
    }
    return Promise.resolve({timeSeries: reply.timeSeries});
  }

  public async getBaseStationMeanPERTimeSeries(query: GetBaseStationTrafficTimeSeriesReq):Promise<HttpResponse & GetBaseStationMeanPERTimeSeriesReply> {
    const reply = await curCoreClient.getBaseStationMeanPERTimeSeries(query);
    if (reply.errorMsg) {
      return Promise.resolve({errorMsg: reply.errorMsg, httpCode: reply.httpCode});
    }
    return Promise.resolve({timeSeries: reply.timeSeries});
  }

  public async getBaseStationCnxTimeSeries(query: GetBaseStationTrafficTimeSeriesReq):Promise<HttpResponse & GetBaseStationCnxStatusTimeSeriesReply> {
    const reply = await curCoreClient.getBaseStationCnxTimeSeries(query);
    if (reply.errorMsg) {
      return Promise.resolve({errorMsg: reply.errorMsg, httpCode: reply.httpCode});
    }
    return Promise.resolve({timeSeries: reply.timeSeries});
  }

  private async getAllBaseStations(): Promise<{errorMsg?:string, httpCode?:number, bssList?:BaseStation[]}> {

    let retList: BaseStation[] = [];

    let skip = 0;
    while (true) {

      const resp = await curCoreClient.getBaseStations({skip, limit: 10000});

      if (resp.errorMsg)
        return Promise.resolve({
          errorMsg:`Unable to load all base stations: ${resp.errorMsg}`, httpCode: resp.httpCode});
      
      if (!resp.bssList || resp.bssList.length === 0)
        break;
      
      retList = retList.concat(resp.bssList);

      if (resp.bssList.length < 10000)
        break;
      
      // we increment skip
      skip += resp.bssList.length;
    }

    return Promise.resolve({bssList: retList});
  }

  private paginateBssList(bssList: BaseStation[], pageSize: number): BssPage[] {

    const chunkedList = _.chunk(bssList, pageSize);

    return chunkedList.map((chunkedListItem:any, index:number) => ({
      pageNum: index,
      bssList: chunkedListItem,
    }));
  }

}

export interface GetBssQuery {
  pageSize: number;
  filter: string;
}

export interface GetBssReply {
  bssPageList?:BssPage[];
}

export interface BssPage {
  pageNum: number;
  bssList: BaseStation[];
}

export interface BaseStationTrafficStats {
  ts: number;
  uplinks: number;
  downlinks: number;
  total: number;
}

export const curBssService = new BssService();
